import { render, staticRenderFns } from "./receitas-emitidas.vue?vue&type=template&id=cbb5a198&"
import script from "./receitas-emitidas.vue?vue&type=script&lang=js&"
export * from "./receitas-emitidas.vue?vue&type=script&lang=js&"
import style0 from "./receitas-emitidas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports